// extracted by mini-css-extract-plugin
export var active = "_1t-9";
export var backButton = "_1t-8";
export var clone = "_1t-e";
export var collapseBar = "_1t-k";
export var collapseMode = "_1t-m";
export var collapsed = "_1t-o";
export var dimmed = "_1t-i";
export var dragHandle = "_1t-c";
export var dropdownIcon = "_1t-g";
export var expanding = "_1t-n";
export var hidden = "_1t-x";
export var iconContainer = "_1t-q";
export var iconSwapper = "_1t-w";
export var navItem = "_1t-6";
export var navItemIcon = "_1t-f";
export var navProfile = "_1t-7";
export var notificationCountBadge = "_1t-j";
export var notificationDot = "_1t-r";
export var optionsContainer = "_1t-h";
export var primaryNav = "_1t-0";
export var primaryNavDivider = "_1t-v";
export var primaryNavResizeHandle = "_1t-2";
export var primaryNavResizing = "_1t-1";
export var primaryNavTabSection = "_1t-u";
export var primaryTab = "_1t-p";
export var primaryTabIconBox = "_1t-s";
export var secondaryNav = "_1t-3";
export var selected = "_1t-t";
export var settingsNav = "_1t-4";
export var settingsNavItems = "_1t-5";
export var show = "_1t-d";
export var sideNav = "_1t-l";
export var teamItem = "_1t-a";
export var userProfileItem = "_1t-b";